'use client';

import { IconButton, styled } from '@mui/material';

import { campaignManagerTheme } from '@campaign-manager/theme';

/**
 * Icon button used for row/toolbar actions (view, edit, clone, download, …).
 *
 * Bakes in the shared neutral background + shadow + hover used by row/toolbar
 * action buttons (see CLAUDE.md
 * "Bottom-Up Styling"). Call sites should still pass an `aria-label` describing
 * the action and put `color="secondary"` on the child icon.
 */
/**
 * The shared action-icon look (neutral bg + shadow + hover). Exported so other
 * components (e.g. ActionButton's `filled` variant) can compose the exact same
 * style instead of re-declaring it.
 */
export const actionIconButtonStyles = {
  backgroundColor: campaignManagerTheme.color.secondaryActionBg,
  boxShadow: campaignManagerTheme.shadow.actionIcon,
  '&:hover': {
    backgroundColor: campaignManagerTheme.color.secondaryActionBgHover,
  },
} as const;

// `styled(IconButton)` drops IconButton's polymorphic anchor typing, so re-declare
// `href`/`target` — passing `href` makes the underlying ButtonBase render an <a>.
const ActionIconButton = styled(IconButton)<{ href?: string; target?: string }>(
  actionIconButtonStyles,
);

export default ActionIconButton;
